import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { MainDashboardService } from "./main-dashboard.service";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { DateRangeReq } from "@gtpl/shared-models/analytics-data";
import { ProductionProcessDashboardReq } from "@gtpl/shared-models/production-management";
import { RmReceivingDashReq } from "@gtpl/shared-models/procurement-management";

@ApiTags('MainDashboard')
@Controller('mainDashboard')
export class MainDashboardController {
    constructor(private  mainDashboardService: MainDashboardService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler){}

    @Post('/getEnquiresStatusWiseCount')
    @ApiBody({type:DateRangeReq})
    async getEnquiresStatusWiseCount(@Body() req:DateRangeReq): Promise <CommonResponse> {
        try {
            return await this.mainDashboardService.getEnquiresStatusWiseCount(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getRawMaterialInward')
    @ApiBody({type:DateRangeReq})
    async getRawMaterialInward(@Body() req:DateRangeReq): Promise <CommonResponse> {
        try {
            return await this.mainDashboardService.getRawMaterialInward(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getSupplierValueWiseDate')
    @ApiBody({type:DateRangeReq})
    async getSupplierValueWiseDate(@Body() req:DateRangeReq): Promise <CommonResponse> {
        try {
            return await this.mainDashboardService.getSupplierValueWiseDate(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }


    @Post('/getMonthWiseSaleOrders')
    @ApiBody({type:DateRangeReq})
    async getMonthWiseSaleOrders(@Body() req:DateRangeReq): Promise <CommonResponse> {
        try {
            return await this.mainDashboardService.getMonthWiseSaleOrders(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getOverDueSaleOrders')
    @ApiBody({type:DateRangeReq})
    async getOverDueSaleOrders(@Body() req:DateRangeReq): Promise <CommonResponse> {
        try {
            return await this.mainDashboardService.getOverDueSaleOrders(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getStockCount')
    @ApiBody({type:DateRangeReq})
    async getStockCount(@Body() req:DateRangeReq): Promise <CommonResponse> {
        try {
            return await this.mainDashboardService.getStockCount(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getDetailStock')
    async getDetailStock(): Promise <CommonResponse> {
        try {
            return await this.mainDashboardService.getDetailStock();
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getTotalProductionForDashboard')
    async getTotalProductionForDashboard(@Body() req?:ProductionProcessDashboardReq): Promise <CommonResponse> {
        try {
            return await this.mainDashboardService.getTotalProductionForDashboard(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    
    @Post('/getClosingStock')
    async getClosingStock(): Promise <CommonResponse> {
        try {
            return await this.mainDashboardService.getClosingStock();
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getDeadStock')
    async getDeadStock(): Promise <CommonResponse> {
        try {
            return await this.mainDashboardService.getDeadStock();
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('getSoakingDataForProductionReport')
    async getSoakingDataForProductionReport(@Body() req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
        try{
            return await this.mainDashboardService.getSoakingDataForProductionReport(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('getYieldProductionReport')
    async getYieldProductionReport(@Body() req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
        try{
            return await this.mainDashboardService.getYieldProductionReport(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('getAntibioticTestResult')
    async getAntibioticTestResult():Promise<CommonResponse>{
        try{
            return await this.mainDashboardService.getAntibioticTestResult();
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('getTodayArrivalQty')
    async getTodayArrivalQty():Promise<CommonResponse>{
        try{
            return await this.mainDashboardService.getTodayArrivalQty();
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('getSaleOrdersData')
    @ApiBody({type:DateRangeReq})
    async getSaleOrdersData(@Body() req: any):Promise<CommonResponse>{
        try{
            return await this.mainDashboardService.getSaleOrdersData(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('getSaleOrdersDetailData')
    @ApiBody({type:DateRangeReq})
    async getSaleOrdersDetailData(@Body() req: any):Promise<CommonResponse>{
        try{
            return await this.mainDashboardService.getSaleOrdersDetailData(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('getRmReceivingReportSummary')
    @ApiBody({type:RmReceivingDashReq})
    async getRmReceivingReportSummary(@Body() req: any):Promise<CommonResponse>{
        try{
            return await this.mainDashboardService.getRmReceivingReportSummary(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

@Post('/getSupllierTypeWiseData')
async getSupllierTypeWiseData(): Promise<CommonResponse>{
   try{
   return await this.mainDashboardService.getSupllierTypeWiseData()
} catch(err){
   return err
}
}
}